
export enum TeamsFixMessagingSettings {
    NONE = 0,
    ALLOW_USER_EDIT_MESSAGES = 1,
    ALLOW_USER_DELETE_MESSAGES = 2,
    ALLOW_OWNER_DELETE_MESSAGES = 4,
}

export enum TeamsFixMemberSettings {
    NONE = 0,
    ALLOW_CREATE_UPDATE_CHANNELS = 1,
    ALLOW_DELETE_CHANNELS = 2,
    ALLOW_ADD_REMOVE_APPS = 4,
    ALLOW_CREATE_UPDATE_REMOVE_TABS = 8,
    ALLOW_CREATE_UPDATE_REMOVE_CONNECTORS = 16,
}

export enum TeamsFixSharePointSiteSettings {
    NONE = 0,
    DOCUMENT_MEMBER_READONLY = 1,
    STYLE_LIBRARY_MEMBER_READONLY = 2,
    SITE_PAGES_MEMBER_READONLY = 4,
    FORM_SERVER_TEMPLATES_MEMBER_READONLY = 8,
}

export enum TeamsFixGroupSettings {
    NONE = 0,
    HIDDEN_FROM_EXCHANGE_CLIENTS_ENABLED = 1,
    HIDDEN_FROM_ADDRESS_LISTS_ENABLED = 2,
}

export enum TeamsFixSettingBehaviour {
    UNDEFINED = 0,
    SET_ONCE = 1,
    FORCE = 2
}

export interface CoreTeamsFix {
    enabled: boolean
    timeZoneId: number | null
    standardSettings: CoreTeamsFixStandardSettings
    archivedSettings: CoreTeamsFixArchivedSettings
}

export interface CoreTeamsFixStandardSettings {
    settingBehaviour: TeamsFixSettingBehaviour
    messagingSettings: TeamsFixMessagingSettings
    memberSettings: TeamsFixMemberSettings
    sharePointSiteSettings: TeamsFixSharePointSiteSettings
    groupSettings: TeamsFixGroupSettings
}

export interface CoreTeamsFixArchivedSettings {
    settingBehaviour: TeamsFixSettingBehaviour
    sharePointSiteSettings: TeamsFixSharePointSiteSettings
    groupSettings: TeamsFixGroupSettings
}

export const MessagingSettings: TeamsFixMessagingSettings[] = [
    TeamsFixMessagingSettings.ALLOW_USER_EDIT_MESSAGES,
    TeamsFixMessagingSettings.ALLOW_USER_DELETE_MESSAGES,
    TeamsFixMessagingSettings.ALLOW_OWNER_DELETE_MESSAGES
]

export const MemberSettings: TeamsFixMemberSettings[] = [
    TeamsFixMemberSettings.ALLOW_CREATE_UPDATE_CHANNELS, 
    TeamsFixMemberSettings.ALLOW_DELETE_CHANNELS, 
    TeamsFixMemberSettings.ALLOW_ADD_REMOVE_APPS, 
    TeamsFixMemberSettings.ALLOW_CREATE_UPDATE_REMOVE_TABS,
    TeamsFixMemberSettings.ALLOW_CREATE_UPDATE_REMOVE_CONNECTORS
]

export const SharePointSiteSettings: TeamsFixSharePointSiteSettings[] = [
    TeamsFixSharePointSiteSettings.DOCUMENT_MEMBER_READONLY, 
    TeamsFixSharePointSiteSettings.STYLE_LIBRARY_MEMBER_READONLY, 
    TeamsFixSharePointSiteSettings.SITE_PAGES_MEMBER_READONLY,
    TeamsFixSharePointSiteSettings.FORM_SERVER_TEMPLATES_MEMBER_READONLY
]

export const GroupSettings: TeamsFixGroupSettings[] = [
    TeamsFixGroupSettings.HIDDEN_FROM_EXCHANGE_CLIENTS_ENABLED,
    TeamsFixGroupSettings.HIDDEN_FROM_ADDRESS_LISTS_ENABLED
]

export const StandardSettingBehaviour: TeamsFixSettingBehaviour[] = [
    TeamsFixSettingBehaviour.SET_ONCE,
    TeamsFixSettingBehaviour.FORCE
];

export const ArchivedSettingBehaviour: TeamsFixSettingBehaviour[] = [
    TeamsFixSettingBehaviour.SET_ONCE,
    TeamsFixSettingBehaviour.FORCE
]